import { render, staticRenderFns } from "./EventsListDetail.vue?vue&type=template&id=46849cd9"
import script from "./EventsListDetail.vue?vue&type=script&lang=js"
export * from "./EventsListDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports